<script>
    const projectName = "kw_plat";//"qcbl_edus_auto";   //edus_auto  online  kw_plat hdgj   文件上传用此名称
    // const fileServeUrl = "https://goacrm.oss-cn-hangzhou.aliyuncs.com/";
    const vueProjectName = "online";//qcbl_edus_auto  vue_kw_plat test_kw_plat  online   hdgj_pdf
   const fileServeUrl = "https://play.keweisoft.com/";
   const baseURL = "https://play.keweisoft.com/kw_plat/";
    const loginBgImage = {};
    const loginProductName = {};
    const loginSecondProductName = {};
    const defaultProductName = "青竹学园";
    const payKey = [
      '87d93bb5a5d24669bab15041d0d11963'
    ];
    // //百利 考试:87d93bb5a5d24669bab15041d0d11963 社会实践:fJum9FzB9U77fiK8JHuApoFOhPQNLxXF
    // //mch_id:'1490528252', 可为
    const mch_id = [
      '1532083511'
    ];
    const app_id = [
      // "wx04c798a380db0bb6"
    ];
    const app_secret = [
      // "87d93bb5a5d24669bab15041d0d11963"
    ];
    //查询支付状态接口页面设置
    const defaultPayStateInfo = {
      "default":{
        tableId:587,
        pageId:13788
      }
    };

    const codePageArr = [{
        tableId: 18073,
        pageId: 22635
      }, {
        tableId: 18073,
        pageId: 22402
      }, {
        tableId: 18382,
        pageId: 22410
      }, {
        tableId: 18073,
        pageId: 27435
      }, {
        tableId: 18073,
        pageId: 29128
      }, {
        tableId: 18400,
        pageId: 30240
      }
    ];

    const proId = '5ee870a2a197a633acc84084/5fc61f07b1648ff6618def39';

    const proIdJson = {
    }
    

    // 查看页面的参数数组
    const lookParam = ["tableId","pageId","pageType","listTableId","mainId","callBackType"];
    // 列表页面的参数数组
    const listParam = ["tableId","pageId","pageType","listTableId","mainId","callBackType","initCheckId","dataMaxNum","sourceListMainId","jumpWay","initSearchVal"];

    const fileServeUrlMap = {}

    export default {
        projectName,
        vueProjectName,
        fileServeUrl,
        baseURL,
        payKey,
        mch_id,
        app_id,
        app_secret,
        proId,
        proIdJson,
        lookParam,
        listParam,
        codePageArr,
        loginBgImage,
        loginProductName,
        loginSecondProductName,
        defaultProductName,
        defaultPayStateInfo,
        fileServeUrlMap
    }
        
</script>